import { useQuery } from '@tanstack/react-query';

import { charityOutreachService } from '@project/services';
import {
  CharityModel,
  CharityOutreachesListModel,
  CharityOutreachesModel,
} from './charity-outreaches.model';

export const useGetCharityOutreach = (id: string) =>
  useQuery(['getCharityOutreach', id], () => charityOutreachService.getCharityOutreach(id), {
    select: CharityOutreachesModel,
  });

export const useGetCharity = (id: string) =>
  useQuery(['getCharity', id], () => charityOutreachService.getCharity(id), {
    select: CharityModel,
  });

export const useGetAllCharityOutreachesQuery = () =>
  useQuery(['getAllCharityOutreaches'], () => charityOutreachService.getAllCharityOutreaches(), {
    select: CharityOutreachesListModel,
  });
